import React, { useEffect, useState } from 'react';
import styles from './styles';
import { RBHAlert, RBHBox, RBHButton, RBHError, RBHTable, RBHText, RBHTextInput, RBHImage, RBHBanner } from '../../../shared/components';
import { Breadcrumb, Col, Menu, Row } from 'antd';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { httpCreators, useLoadingSelector } from 'rbh-merchant-core';
import { BRANCH_REQUEST_ID_LIST } from './redux/branch-constant';
import { branchSagas } from './redux/branch-saga';
import { BranchService } from './redux/branch-service';
import { BRANCH_STATE_KEY, branchStateSelector } from './redux/branch-reducer';
import { FormAddEdit } from './components/FormAddEdit';
import styleText from '../../../shared/components/rbh-text/styles';
import styleImage from '../../../shared/components/rbh-image/styles';
import styleButton from '../../../shared/components/rbh-button/styles';
import styleInput from '../../../shared/components/rbh-textinput/styles';
import { mainCreators } from '../../main-action';
import { MAIN_STATE_KEY } from '../../main-reducer';
import { BUSINESS_TYPE, SQC_STATUS } from '../../main-constant';
import {
  DeleteOutlined,
  EditOutlined,
  FilterFilled,
  LinkOutlined,
  SearchOutlined,
  ShopOutlined
} from '@ant-design/icons';
import { generalCreators } from '../../../redux/general/general-action';
import { GENERAL_STATE_KEY } from '../../../redux/general/general-reducer';
import { DEFAULT_PAGE_SIZE, MODAL_TYPE } from '../../../redux/general/general-constant';
import metrics from '../../../shared/theme/metrics';
import { branchCreators } from './redux/branch-action';
import { MainHelper } from '../../main-helper';
import { VAT_REQUEST_ID_LIST } from '../VatAddress/redux/vat-constant';
import { VatService } from '../VatAddress/redux/vat-service';
import { UtilHelper } from '../../../shared/helpers/utility';
import { Colors, Images } from '../../../shared/theme';
import RBHQCTag from '../../../shared/components/rbh-qc-tag';
import { authCreators } from '../../../auth/auth-action';
import { AuthHelper } from '../../../auth/auth-helper';

export const BranchManagementScreen: React.FC<Props> = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const branchData = useSelector(branchStateSelector(BRANCH_STATE_KEY.BRANCH_LIST)) as [];
  const alertSuccess = useSelector(branchStateSelector(BRANCH_STATE_KEY.ALERT_SUCCESS));
  const alertFail = useSelector(branchStateSelector(BRANCH_STATE_KEY.ALERT_FAIL));
  const loading = useLoadingSelector(BRANCH_REQUEST_ID_LIST.GET_BRANCH);
  const [edit, setEdit] = useState(null);
  const branchStatusCode = MainHelper.getMasterDataByScheme('ShopStatus');
  const branchOpenHourStatusCode = MainHelper.getMasterDataByScheme('OpenHourStatus');
  const businessTypeId = AuthHelper.getBusinessTypeId();
  const isMart = businessTypeId === BUSINESS_TYPE.MART;

  useEffect(() => {
    dispatch(mainCreators.setMainState(MAIN_STATE_KEY.HEADER_MENU, 1));
    reload();
  }, []);

  const pushToMain = () => {
    history.push('/main');
  };

  const pushToBranch = () => {
    resetReload();
  };

  const resetReload = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setEdit(null);
    dispatch(branchCreators.callBranch());
  };

  const reload = () => {
    dispatch(branchCreators.callBranch());
  };

  const onAdd = () => {
    if (!(businessTypeId in BUSINESS_TYPE)) {
      dispatch(authCreators.logOut());
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      history.push('/main/addbranch');
    }
  };

  const onPOSManagement = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    history.push('/main/posmanagement');
  };

  const onDeleteBranch = (id: any) => {
    dispatch(httpCreators.request({
      id: isMart ? BRANCH_REQUEST_ID_LIST.DELETE_MART_BRANCH : BRANCH_REQUEST_ID_LIST.DELETE_BRANCH,
      sagaHandler: branchSagas.deleteBranchHandler as any,
      callbackParams: resetReload,
      service: isMart ? BranchService.deleteMartBranch : BranchService.deleteBranch,
      serviceParams: id
    }));
  };

  const toBranchMapping = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    history.push('/main/branchmanagement/assignvat');
  };

  const callVat = () => {
    dispatch(httpCreators.request({
      id: VAT_REQUEST_ID_LIST.GET_VAT,
      sagaHandler: branchSagas.getVatHandler as any,
      callbackParams: toBranchMapping,
      service: VatService.getVat,
      serviceParams: ''
    }));
  };

  const handleSuccessClose = () => {
    dispatch(branchCreators.setBranchState(BRANCH_STATE_KEY.ALERT_SUCCESS, false));
  };

  const handleFailClose = () => {
    dispatch(branchCreators.setBranchState(BRANCH_STATE_KEY.ALERT_FAIL, false));
  };

  setTimeout(() => {
    if (alertSuccess) {
      dispatch(branchCreators.setBranchState(BRANCH_STATE_KEY.ALERT_SUCCESS, false));
    } else if (alertFail) {
      dispatch(branchCreators.setBranchState(BRANCH_STATE_KEY.ALERT_FAIL, false));
    }
  }, 3000);

  const isAlert = () => {
    if (alertSuccess) {
      return (
        <RBHBox id={'alertSuccess'} data-testid={'alertSuccess'}>
          <RBHAlert type={'success'} text={'main.branchmapping.alert.success'} afterClose={handleSuccessClose} /><br />
        </RBHBox>
      );
    } else if (alertFail) {
      return (
        <RBHBox id={'alertFail'} data-testid={'alertFail'}>
          <RBHAlert type={'error'} text={'main.branchmapping.alert.fail'} afterClose={handleFailClose} /><br />
        </RBHBox>
      );
    }
    return null;
  };

  const onMenuItemClick = (setSelectedKeys: any, selectedKeys: any, confirm: any, clearFilters: any, value: any) => {
    if (selectedKeys[0] === value) {
      clearFilters();
    } else {
      setSelectedKeys([value]);
      confirm();
    }
  };

  const columns = [
    {
      width: metrics.tableHeader.width100,
      title: <FormattedMessage id={'main.branchtable.shopId'} />,
      dataIndex: 'shopId',
      render: (value: any, all: any, index: number) => {
        const shopId = 'shopId-' + index;
        return (
          <RBHBox style={{ color: Colors.font.primary.fakeBlack }} data-testid={shopId} id={shopId}>
            {value}
          </RBHBox>
        );
      }
    },
    {
      width: metrics.tableHeader.width325,
      title: <FormattedMessage id={'main.branchtable.branchname'} />,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => {
        return (
          <RBHBox style={styles.searchBox}>
            <RBHTextInput
              placeholder={'main.branchtable.addbranchname'}
              data-testid={'search-branch-input'}
              id={'search-branch-input'}
              style={styleInput.inputTableSearch}
              value={selectedKeys[0]}
              onChange={(e: any) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
              }}
              onPressEnter={confirm}
              onBlur={confirm}
            />
          </RBHBox>
        );
      },
      filterIcon: (filtered: any) => (
        <SearchOutlined data-testid={'search-branch-icon'} id={'search-branch-icon'}
          translate={null} style={{ color: filtered ? Colors.lightPurple : Colors.font.primary.gray }} />
      ),
      onFilter: (value: any, all: any) => {
        return all.shopName.toString().toLowerCase().includes(value.toLowerCase());
      },
      onFilterDropdownVisibleChange: (visible: boolean) => {
        if (visible) {
          setTimeout(() => {
            const inputEl = document.getElementById('search-input');
            if (inputEl) {
              (inputEl as HTMLInputElement).select();
            }
          });
        }
      },
      render: (value: any, all: any, index: number) => {
        const shopNameId = 'id-shopName-' + index;
        const branchCode = 'id-branchCode-' + index;
        const addressId = 'id-address-' + index;
        const phoneId = 'id-phone-' + index;
        return (
          <RBHBox style={{ maxWidth: metrics.tableHeader.width325 }}>
            <RBHText data-testid={shopNameId} id={shopNameId} style={styleText.textMedium12}>{all.shopName}</RBHText>
            {all.branchCode &&
              <RBHText data-testid={branchCode} id={branchCode} style={styles.textRegular12Gray}>
                  <FormattedMessage id={'main.branchmapping.refcode'} /> {all.branchCode}
              </RBHText>
            }
            <RBHBox data-testid={addressId} id={addressId} style={styles.textRegular12Gray}>
              {/* tslint:disable-next-line:max-line-length */}
              {all.address.addressDetail} {all.address.addressSubdistrict} {all.address.addressDistrict} {all.address.addressProvince} {all.address.addressPostalCode}
            </RBHBox>
            <RBHBox data-testid={phoneId} id={phoneId} style={styles.textRegular12Gray}>
              <FormattedMessage id={'main.branchmapping.tel'} /> {all.shopPhoneNo}
            </RBHBox>
          </RBHBox>
        );
      }
    },
    {
      title: <FormattedMessage id={'main.branchtable.branchopen'} />,
      dataIndex: 'openHours',
      width: metrics.tableHeader.width150,
      render: (value: any, all: any, index: number) => (
        <RBHBox data-testid={`id-allday-${index}`} id={`id-allday-${index}`} style={{ width: metrics.tableHeader.width125 }}>
          {value.map((v: any, i: any) => {
            const weekday = v.weekdayId === 1 ? 'อาทิตย์' :
              v.weekdayId === 2 ? 'จันทร์' :
                v.weekdayId === 3 ? 'อังคาร' :
                  v.weekdayId === 4 ? 'พุธ' :
                    v.weekdayId === 5 ? 'พฤหัสบดี' :
                      v.weekdayId === 6 ? 'ศุกร์' :
                        v.weekdayId === 7 ? 'เสาร์' : '';
            const weekId = 'id-' + index + '-weekId-' + i;
            const hourId = 'id-' + index + '-hourId-' + i;
            const closeId = 'id-' + index + '-closeId-' + i;
            return (
              v.openHourStatus === branchOpenHourStatusCode[0] ?
                <Row id={`id-day-${i}`} key={i}>
                  <Col id={weekId} flex='50px'>{weekday}</Col>
                  <Col id={hourId}>{v.openHour.substring(0, 5)}</Col>
                  <Col>-</Col>
                  <Col id={closeId}>{v.closeHour.substring(0, 5)}</Col>
                </Row> : null
            );
          })}
        </RBHBox>
      )
    },
    {
      width: metrics.tableHeader.width140,
      title: <FormattedMessage id={'main.branchtable.branchstatus'} />,
      dataIndex: 'shopStatus',
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => {
        return (
          <Menu style={styleText.textTableContent} selectable={false}>
            {
              branchStatusCode.map((code: string) => {
                return (
                  <Menu.Item
                    key={code}
                    id={code}
                    data-testid={code}
                    style={selectedKeys[0] === code ? styles.selectedMenuItem : {}}
                    onClick={() => onMenuItemClick(setSelectedKeys, selectedKeys, confirm, clearFilters, code)}
                  >
                    {MainHelper.getMasterDataByCode(code)}
                  </Menu.Item>
                );
              })
            }
          </Menu>
        );
      },
      filterIcon: (filtered: any) => (
        <FilterFilled data-testid={'filter-status-icon'} id={'filter-status-icon'}
          translate={null} style={{ color: filtered ? Colors.lightPurple : Colors.font.primary.gray }} />
      ),
      onFilter: (value: boolean, all: any) => {
        return all.shopStatus === value;
      },
      render: (value: any, all: any, index: number) => {
        const closeStatusText = value === 'SS02' ?
          all.nextOpenDateTime ? <FormattedMessage id={'main.branchtable.willOpen'}
            values={{ date: UtilHelper.formatThaiDate(all.nextOpenDateTime) }} />
            : all.nextOpenDateTime === null ? <FormattedMessage id={'main.branchtable.closedIndefinitely'} /> : '' : '';
        const indexId = 'id-branch-status-' + index;
        const qcIndexId = 'id-branch-qc-status-' + index;
        return (<>
          <div style={{ width: metrics.tableHeader.width120, whiteSpace: 'pre'}} data-testid={indexId}
               id={indexId}>{MainHelper.getMasterDataByCode(value)}{closeStatusText}</div>
          <RBHQCTag qcStatus={all?.shopQCStatus} id={qcIndexId} marginTop={3}/>
        </>);
      }
    },
    {
      width: metrics.tableHeader.width30,
      align: 'center',
      title: <FormattedMessage id={'main.branchtable.branchedit'} />,
      dataIndex: 'shopId',
      render: (value: any, all: any, index: number) => {
        const indexId = 'id-edit-' + index;
        const indexIdIcon = 'id-edit-icon-' + index;
        return (<RBHBox style={{ width: metrics.tableHeader.width30 }} id={indexId}>
          <EditOutlined onClick={() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            if (!(businessTypeId in BUSINESS_TYPE)) {
              dispatch(authCreators.logOut());
            } else {
              setEdit(all);
            }
          }} data-testid={indexIdIcon} id={indexIdIcon} translate={null} style={styleImage.iconTable} />
        </RBHBox>);
      }
    },
    {
      width: metrics.tableHeader.width20,
      align: 'center',
      title: <FormattedMessage id={'main.branchtable.branchdelete'} />,
      dataIndex: 'shopId',
      render: (shopId: any, all: any, index: number) => {
        const indexId = 'id-delete-' + index;
        const indexIdIcon = 'id-delete-icon-' + index;
        const isDelete = all.merchantUser ? all.merchantUser.userRoleCode === 'OWNER' ? false : true : true;
        return (
          isDelete ? <RBHBox style={{ width: metrics.tableHeader.width20 }} id={indexId}>
            <DeleteOutlined onClick={() => dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
                visible: true,
                onOk: () => onDeleteBranch(shopId),
                modalTitle: 'main.modal_delete_confirm_header',
                modalContent: 'main.modal_delete_confirm_branch_content',
                type: MODAL_TYPE.DELETE
              }))}
              id={indexIdIcon} data-testid={indexIdIcon} translate={null} style={styleImage.iconTable} />
          </RBHBox> : null
        );
      }
    },
  ];

  const BreadcrumbRender = () => {
    return (
      <RBHBox>
        <Breadcrumb style={styleText.breadCrumb}>
          <Breadcrumb.Item>
            <a data-testid={'id-branch-breadcrumb-home'}
              id={'id-branch-breadcrumb-home'} style={styleText.breadCrumbItemLink} onClick={() => {
                history.push('/main');
              }}>
              <FormattedMessage id={'main.main'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span data-testid={'id-branch-breadcrumb-branchmanagement-invisible'}
              id={'id-branch-breadcrumb-branchmanagement-invisible'} style={styleText.breadCrumbItem}>
              <FormattedMessage id={'main.branchmanagement'} />
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
      </RBHBox>
    );
  };

  const BreadcrumbEditRender = () => {
    return (
      <RBHBox>
        <Breadcrumb style={styleText.breadCrumb}>
          <Breadcrumb.Item>
            <a data-testid={'id-editbranch-breadcrumb-home'} id={'id-editbranch-breadcrumb-home'} style={styleText.breadCrumbItemLink} onClick={() =>
              dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL,
                { visible: true, onOk: pushToMain, type: MODAL_TYPE.CONFIRM_EDIT }))}>
              <FormattedMessage id={'main.main'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <a data-testid={'id-editbranch-breadcrumb-branchmanagement'}
              id={'id-editbranch-breadcrumb-branchmanagement'} style={styleText.breadCrumbItemLink} onClick={() =>
                dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL,
                  { visible: true, onOk: pushToBranch, type: MODAL_TYPE.CONFIRM_EDIT }))}>
              <FormattedMessage id={'main.branchmanagement'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span data-testid={'id-editbranch-breadcrumb-editbranch-invisible'}
              id={'id-editbranch-breadcrumb-editbranch-invisible'} style={styleText.breadCrumbItem}>
              <FormattedMessage id={'main.editbranch'} />
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
      </RBHBox>
    );
  };

  const TabRender = () => {
    return (
      <RBHBox style={styles.header}>
        <RBHText data-testid={'id-addbranch-title'} id={'id-addbranch-title'} style={styleText.headerText} text={'main.branchmanagement'} />
        {branchData === undefined || branchData.length < 1 ? null :
          <RBHBox>
            { businessTypeId === BUSINESS_TYPE.FOOD &&
              <RBHButton
                data-testid={'pos-management-btn'}
                id={'pos-management-btn'}
                style={styles.buttonPos}
                text={'main.posManagement.landing.posManagement'}
                type='primary'
                icon={<RBHImage style={styles.posIcon} src={Images.posIcon}
                  data-testid={'pos-management-icon'} id={'pos-management-icon'}/>}
                onClick={() => onPOSManagement()}>
              </RBHButton>
            }
            <RBHButton
              data-testid={'id-addbranch'}
              id={'id-addbranch'}
              style={styleButton.buttonAdd}
              text={'main.addbranch'}
              type='primary'
              icon={<ShopOutlined translate={null} />}
              onClick={() => onAdd()}>
            </RBHButton>
          </RBHBox>
        }
      </RBHBox>
    );
  };

  const GetVatAddressRender = () => {
    return (
      <RBHBox style={styles.paddingTabVatAddress}>
        <RBHButton
          data-testid={'id-showmapping'}
          id={'id-showmapping'}
          style={styleButton.buttonAdd}
          text={'main.branchmapping.title'}
          type='primary'
          icon={<LinkOutlined translate={null} />}
          onClick={callVat}>
        </RBHButton>
      </RBHBox>
    );
  };

  const qcRejectMessage = (rejectReason: string[]) => {
    return (
      <RBHBox>
       <RBHText style={styles.textRegular14ErrorRed} data-testid={'id-text-reject-banner-title'} id={'id-text-reject-banner-title'}
        text={ rejectReason?.length > 0 ? 'main.editbranch.qc.reject.reason.title' : 'main.editbranch.qc.reject.title'} />
        {rejectReason?.length > 0 &&
          <RBHBox style={styles.qcRejectReason}>
            <ul>
            {rejectReason.map((reason: string, index: any) => {
              return(
              <li style={styles.textRegular14ErrorRed} data-testid={`id-text-reject-reason-${index}`} id={`id-text-reject-reason-${index}`}>
                {reason}
              </li>
              );
            })}
            </ul>
          </RBHBox>
        }
        <RBHText style={styles.textRegular14ErrorRed} data-testid={'id-text-reject-banner-description'} id={'id-text-reject-banner-description'}
        text={'main.editbranch.qc.reject.desc'} />
      </RBHBox>
    );
  };

  const showShopQCRejectBanner = (editData: any) => {
    return(
      <>
      {editData?.shopQCStatus === SQC_STATUS.SQC_REJECT  && (
        <RBHBox style={styles.qcRejectBanner}>
          <RBHBanner type={'error'} message={qcRejectMessage(editData?.rejectReason)}  />
        </RBHBox>
      )}
      </>
    );
  };

  return (
    <RBHBox>
      {isAlert()}
      {edit ? BreadcrumbEditRender() : BreadcrumbRender()}
      {loading ? null :
        edit ?
          <RBHBox>
            <RBHBox style={styles.header}>
              <RBHText data-testid={'id-text-edit-branch'} id={'id-text-edit-branch'} style={styleText.headerText}
                text={'main.editbranch'} />
            </RBHBox>
            <RBHBox style={styles.headerRemark}>
              <RBHText data-testid={'id-text-edit-branch-remark'} id={'id-text-edit-branch-remark'} style={styles.textRegular14DarkGray}
                text={'main.editbranch.remark'} />
            </RBHBox>
            {showShopQCRejectBanner(edit)}
            <RBHBox style={styles.defaultContent}>
              <FormAddEdit editData={edit} onSuccessCallback={pushToBranch} onCancel={() =>
                dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL,
                  { visible: true, onOk: pushToBranch, type: MODAL_TYPE.CONFIRM_EDIT }))} />
            </RBHBox>
          </RBHBox>
          :
          <RBHBox>
            {TabRender()}
            <RBHBox style={styles.subTitleText} data-testid={'id-branch-subtitle'} id={'id-branch-subtitle'}>
              <FormattedMessage id={'main.branchmapping.subtitle'} />
            </RBHBox>
            <RBHBox>
              {branchData === undefined || branchData.length < 1 ?
                <RBHError onOk={() => resetReload()} />
                :
                <RBHBox style={styles.defaultContent}>
                  <RBHBox>
                    {GetVatAddressRender()}
                    <RBHTable
                      rowKey={'shopId'}
                      columns={columns}
                      dataSource={branchData}
                      rowClassName={(record: any) => {
                        if (record.shopStatus !== branchStatusCode[0]) {
                          return 'disabled-new';
                        }
                        return '';
                      }}
                      pagination={{
                        showSizeChanger: false,
                        pageSize: DEFAULT_PAGE_SIZE,
                        position: ['bottomLeft'],
                        hideOnSinglePage: true,
                        showTotal: (total: number, range: number[]) => {
                          return (
                            <RBHText style={styleText.textPaginationShowTotal}>
                              <FormattedMessage id={'main.showing'} />
                              <span data-testid={'id-bottom-rage-page'} id={'id-bottom-rage-page'}> {range[0] + '-' + range[1]} </span>
                              <FormattedMessage id={'main.of'} />
                              <span data-testid={'id-bottom-total-page'} id={'id-bottom-total-page'}> {total}</span>
                            </RBHText>
                          );
                        }
                      }}>
                    </RBHTable>
                  </RBHBox>
                </RBHBox>}
            </RBHBox>
          </RBHBox>}
    </RBHBox >
  );
};

type Props = {};
